
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/coach/[usernameOrId]",
      function () {
        return require("private-next-pages/coach/[usernameOrId]/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/coach/[usernameOrId]"])
      });
    }
  